import React, {useState} from 'react';
import './Portfolio.scss';
import Project from "./Project/Project";
import InfinityCarousel from "../../helpers/InfinityCarousel/InfinityCarousel";
import ModalComponent from "./ModalComponent/ModalComponent";
import {smallProjectList, projectListForModal} from './PortfolioData';

function Portfolio() {
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [currentProject, setCurrentProject] = useState<any>(null);
    
    const onClick = (id: string) => {
        setIsOpenModal(true);
        setCurrentProject(projectListForModal.find((e) => e.id === parseInt(id)));
    }

    return (
        <div className="Portfolio modal-bg">
            <div className="content">
                <div className={'titleKey'}>Selected Systems & Environments</div>
                <div className={'title'}>Systems & Environments We Have Engineered</div>
                <div className={'underTitleText'}>
                    <div>Real-world systems designed and operated under complexity, scale and operational constraints.
                    </div>
                </div>
            </div>
            <InfinityCarousel
                items={smallProjectList}
                itemRender={Project}
                itemWidth={280}
                loop
                onElementClick={onClick}
            />
            <ModalComponent
                isOpen={isOpenModal}
                closeModal={() => setIsOpenModal(false)}
                project={currentProject}
            />
            <div className={'underProjectText'}>
                We design systems that operate under real-world constraints: <br/>
                high load, regulatory requirements, incomplete data and evolving conditions.
            </div>
            <div className={'underProjectText_2'}>
                Some systems and environments cannot be publicly detailed. <br/>
                Additional experience is available upon request.
            </div>
            {/*<div id={'our-team'}/>*/}
        </div>
    );
}

export default Portfolio;